import { GERMAN_FEDERAL_STATES } from '../../../../apiServices/additionalCharge.service';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
var t = getTranslation(translations);
var federalStatesOptions = [
    {
        label: t.federalStateOption_BADEN_WURTTEMBERG,
        value: GERMAN_FEDERAL_STATES.BADEN_WURTTEMBERG,
    },
    { label: t.federalStateOption_BAYERN, value: GERMAN_FEDERAL_STATES.BAYERN },
    { label: t.federalStateOption_BERLIN, value: GERMAN_FEDERAL_STATES.BERLIN },
    {
        label: t.federalStateOption_BRANDENBURG,
        value: GERMAN_FEDERAL_STATES.BRANDENBURG,
    },
    { label: t.federalStateOption_BREMEN, value: GERMAN_FEDERAL_STATES.BREMEN },
    { label: t.federalStateOption_HAMBURG, value: GERMAN_FEDERAL_STATES.HAMBURG },
    { label: t.federalStateOption_HESSEN, value: GERMAN_FEDERAL_STATES.HESSEN },
    {
        label: t.federalStateOption_MECKLENBURG_VORPOMMERN,
        value: GERMAN_FEDERAL_STATES.MECKLENBURG_VORPOMMERN,
    },
    {
        label: t.federalStateOption_NIEDERSACHSEN,
        value: GERMAN_FEDERAL_STATES.NIEDERSACHSEN,
    },
    {
        label: t.federalStateOption_NORDRHEIN_WESTFALEN,
        value: GERMAN_FEDERAL_STATES.NORDRHEIN_WESTFALEN,
    },
    {
        label: t.federalStateOption_RHEINLAND_PFALZ,
        value: GERMAN_FEDERAL_STATES.RHEINLAND_PFALZ,
    },
    {
        label: t.federalStateOption_SAARLAND,
        value: GERMAN_FEDERAL_STATES.SAARLAND,
    },
    { label: t.federalStateOption_SACHSEN, value: GERMAN_FEDERAL_STATES.SACHSEN },
    {
        label: t.federalStateOption_SACHSEN_ANHALT,
        value: GERMAN_FEDERAL_STATES.SACHSEN_ANHALT,
    },
    {
        label: t.federalStateOption_SCHLESWIG_HOLSTEIN,
        value: GERMAN_FEDERAL_STATES.SCHLESWIG_HOLSTEIN,
    },
    {
        label: t.federalStateOption_THURINGEN,
        value: GERMAN_FEDERAL_STATES.THURINGEN,
    },
];
export default {
    federalStatesOptions: federalStatesOptions,
};
